/**
 * Notable non-federal observances relevant to retail sales patterns
 * (e.g. Father's Day, Mother's Day). These are display-only annotations —
 * distinct from the federal_holidays config used for business-day logic.
 */

function isoDate(year: number, month: number, day: number): string {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

/** Return the date of the nth occurrence (1-indexed) of a weekday (0=Sun) in a month. */
function nthWeekday(year: number, month: number, weekday: number, n: number): string {
  const first = new Date(year, month - 1, 1)
  const firstWeekday = first.getDay()
  const offset = (weekday - firstWeekday + 7) % 7
  const day = 1 + offset + (n - 1) * 7
  return isoDate(year, month, day)
}

function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T12:00:00`)
  d.setDate(d.getDate() + days)
  return d.toISOString().slice(0, 10)
}

function retailObservancesForYear(year: number): Record<string, string> {
  const thanksgiving = nthWeekday(year, 11, 4, 4)

  return {
    [isoDate(year, 2, 14)]: "Valentine's Day",
    [isoDate(year, 3, 17)]: "St. Patrick's Day",
    [nthWeekday(year, 5, 0, 2)]: "Mother's Day",
    [nthWeekday(year, 6, 0, 3)]: "Father's Day",
    [isoDate(year, 10, 31)]: 'Halloween',
    [addDays(thanksgiving, 1)]: 'Black Friday',
    [addDays(thanksgiving, 4)]: 'Cyber Monday',
    [isoDate(year, 12, 24)]: 'Christmas Eve',
    [isoDate(year, 12, 31)]: "New Year's Eve",
  }
}

/** Observance names keyed by ISO date, for the given inclusive year range. */
export function getRetailObservances(startYear: number, endYear: number): Record<string, string> {
  const merged: Record<string, string> = {}
  for (let year = startYear; year <= endYear; year += 1) {
    Object.assign(merged, retailObservancesForYear(year))
  }
  return merged
}
